import { inputUtility } from "@repo/utilities/input.utility.ts";
import Selector from "../../DropMenu/Selector";
import TextInput from "../../Inputs/TextInput";
import { Controller, useFormContext } from "react-hook-form";
import { BasicObject } from "Tables/table.types";
import SearchSelector from "../../DropMenu/SearchSelector";
import { UiCheckbox } from "../../Toggles/UiCheckbox";

function FilterType({ data }: { data: BasicObject }) {
  const { control, setValue, watch } = useFormContext();
  const code = data?.code;
  if (data?.type === "text") {
    return (
      <section className="flex justify-start gap-3 w-64">
        <div className="pt-4">
          <Controller
            name={`${data.code}_enabled`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <UiCheckbox
                enabled={value || false}
                setEnabled={onChange}
                disabled={!watch(data.code)?.trim().length}
              />
            )}
          />
        </div>
        <TextInput
          name={data.code}
          label={data.name}
          type={data.type}
          registerOptions={{
            onChange: (e) => {
              const val = e.target.value.trim();
              setValue(`${data.code}_enabled`, !!val, { shouldDirty: true });

              if (code === "proposer-name") {
                inputUtility.onlyAlphabets(e, 50);
              }
            },
          }}
          className="h-6"
        />
      </section>
    );
  }
  if (data?.type === "number") {
    return (
      <section className="flex items-center justify-center gap-3  w-64 ">
        <div className="pt-4">
          <Controller
            name={`${data.code}_enabled`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <UiCheckbox
                enabled={value || false}
                setEnabled={onChange}
                disabled={!watch(data.code)?.trim().length}
              />
            )}
          />
        </div>
        <TextInput
          name={data.code}
          label={data.name}
          type="text"
          registerOptions={{
            onChange: (e) => {
              inputUtility.onlyNumbersAndDot(e);
              const val = e.target.value.trim();
              setValue(`${data.code}_enabled`, !!val, { shouldDirty: true });
            },
          }}
          className="h-6"
        />
      </section>
    );
  }
  if (data?.type === "selector") {
    return (
      <section className="flex items-center justify-center gap-3 w-64">
        <div className="pt-4">
          <Controller
            name={`${data.code}_enabled`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <UiCheckbox
                enabled={value || false}
                setEnabled={onChange}
                disabled={!watch(data.code)}
              />
            )}
          />
        </div>
        <Controller
          name={data.code}
          control={control}
          render={({ field: { value, onChange } }) => (
            <Selector
              label={data.name}
              value={value}
              onChange={(value) => {
                onChange(value);
                if (value) {
                  setValue(`${data.code}_enabled`, true, { shouldDirty: true });
                }
              }}
              placeholder=""
              options={data.option || []}
              className="h-6"
              isRequired={false}
            />
          )}
        />
      </section>
    );
  }
  if (data?.type === "searchSelector") {
    return (
      <section className="flex justify-between w-44">
        <div className="pt-4">
          <Controller
            name={`${data.code}_enabled`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <UiCheckbox
                enabled={value || false}
                setEnabled={onChange}
                disabled={!watch(data.code)?.trim().length}
              />
            )}
          />
        </div>
        <Controller
          name={data.name}
          rules={{ required: `${data.name}` }}
          control={control}
          render={({ field: { value, onChange } }) => (
            <SearchSelector
              label={data.name}
              value={value}
              onChange={(value) => {
                onChange(value);
                if (value?.trim()) {
                  setValue(`${data.code}_enabled`, true, { shouldDirty: true });
                }
              }}
              placeholder=""
              options={data.option || []}
              query={data?.query || ""}
              setQuery={(value) => {
                data.setQuery?.(value);
                if (value.trim()) {
                  setValue(`${data.code}_enabled`, true, { shouldDirty: true });
                }
              }}
              validateQuery={(e) => {
                inputUtility?.onlyAlphabets(e, 20);
              }}
              className="h-6"
            />
          )}
        />
      </section>
    );
  }
  if (data?.type === "date") {
    return (
      <section className="flex flex-col items-start justify-center w-44">
        <div className="pt-4">
          <Controller
            name={`${data.code}_enabled`}
            control={control}
            render={({ field: { value, onChange } }) => (
              <UiCheckbox
                enabled={value || false}
                setEnabled={onChange}
                disabled={!watch(data.code)?.trim().length}
              />
            )}
          />
        </div>
        <TextInput
          label={data.name}
          name={data.name}
          type={data.type}
          registerOptions={{
            onChange: (e) => {
              const val = e.target.value;
              if (val.trim()) {
                setValue(`${data.code}_enabled`, true, { shouldDirty: true });
              }
            },
          }}
          className="h-6"
        />
      </section>
    );
  }
}

export default FilterType;
